import { Box, Typography } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { UkuranBadanCardMini } from './PageProductDetailSizeOptions';

// Floating "currently measuring" header. Duplicated from the sharescreen overlay
// (OverlayViewOfflineSharescreen) so the same LIVE / SEDANG MENGUKUR / size card /
// name banner can float over the offline measurement flow screens.
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        floatingHeader: {
            position: "relative",
            width: "100%",
            height: "8vw",
            boxSizing: "border-box",
            display: "flex",
            justifyContent: "center",
            zIndex: 15000,
            pointerEvents: "none",
        },
        headerBar: {
            position: "fixed",
            top: "30px",
            width: "68%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "#ffffff",
            borderRadius: "1000px",
            padding: "0.667vw 1vw",
            boxShadow: "0px 0.6vw 2.4vw rgba(0, 0, 0, 0.13)",
        },
        statusText: {
            fontWeight: 400,
            fontSize: "0.803vw",
            letterSpacing: "0.04vw",
            color: "#2a2a2a",
            whiteSpace: "nowrap",
            paddingTop: '0.25vw',
            marginLeft: "1.4vw",
        },
        liveDot: {
            width: "1vw",
            height: "1vw",
            borderRadius: "50%",
            marginLeft: "0.6vw",
            backgroundColor: "rgb(13, 118, 7)",
            animation: "$liveBlink 2.5s ease-in-out infinite",
        },
        headerCardSlot: {
            position: "relative",
            alignSelf: "stretch",
            width: "5vw",
        },
        headerCard: {
            position: "absolute",
            left: "50%",
            top: "65%",
            transform: "translate(-50%, -50%)",
        },
        headerCardWiggle: {
            transformOrigin: "center bottom",
            animation: "$cardWiggle 3s ease-in-out infinite",
        },
        headerName: {
            fontWeight: 600,
            fontSize: "1.533vw",
            color: "#121212",
            whiteSpace: "nowrap",
            marginLeft: "1.7vw",
            marginRight: "2vw",
        },
        "@keyframes liveBlink": {
            "0%": { opacity: 1 },
            "50%": { opacity: 0.15 },
            "100%": { opacity: 1 },
        },
        "@keyframes cardWiggle": {
            "0%": { transform: "rotate(0deg)" },
            "2%": { transform: "rotate(-7deg)" },
            "5%": { transform: "rotate(6deg)" },
            "8%": { transform: "rotate(-5deg)" },
            "11%": { transform: "rotate(4deg)" },
            "14%": { transform: "rotate(-2deg)" },
            "17%": { transform: "rotate(0deg)" },
            "100%": { transform: "rotate(0deg)" },
        },
    })
);

export default function OfflineMeasuringHeader({ firstName }: { firstName: string }) {
    const classes = useStyles();

    return (
        <Box className={classes.floatingHeader}>
            <Box className={classes.headerBar}>
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography className={classes.statusText}>SEDANG MENGUKUR</Typography>
                    <Box className={classes.liveDot} />
                </Box>
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                    <Box className={classes.headerCardSlot}>
                        <Box className={classes.headerCard}>
                            <Box className={classes.headerCardWiggle}>
                                <UkuranBadanCardMini nama={firstName ? firstName : '-'} width={"5vw"} fontSize={"0.667vw"} />
                            </Box>
                        </Box>
                    </Box>
                    <Typography className={classes.headerName}>{firstName ? firstName : '-'}</Typography>
                </Box>
            </Box>
        </Box>
    );
}
